import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { UnblockStateData } from './types';

const initialState: UnblockStateData = {
	data: { data: { message: '', error: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchUnblock = createAsyncThunk('api/fetchUnblock', (action: string) => api.fetchUnblock(action));

const voluntaryUnblockSlice = createSlice({
	name: 'voluntaryUnblock',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchUnblock.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchUnblock.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchUnblock.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default voluntaryUnblockSlice.reducer;
